var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScannFail5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 682.667 682.667",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 512h512V0H0Z",
    fill: "#b04a4a",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 682.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 21.827 32.096c7.151 10.626 2.426 25.142-9.61 29.523a19.71 19.71 0 0 1-22.068-6.13l-24.45-29.927z",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(471.107 357.691)",
    fill: "#ffffff",
    "data-original": "#e08369",
    className: "",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a157.758 157.758 0 0 1 42.022 62.684l24.524 67.374a69.901 69.901 0 0 0 11.417 20.149l53.773 66.233a21.409 21.409 0 0 0 23.942 6.623c13.128-4.778 18.235-20.646 10.359-32.185l-31.355-45.933-15.479-9.829 1.593-11.806c1.054.26 2.132.432 3.224.523 0 0 5.407-1.569 8.515-2.85 9.597-3.953 11.541-14.506 8.8-24.517l-14.871-53.339a126.695 126.695 0 0 1-4.393-28.338l-.313-7.788a71.38 71.38 0 0 0-60.404-67.664C47.768-62.766 35.986-71.208 29.139-83.13l-38.11-66.051a7.997 7.997 0 0 0-6.936-4.015l-67.712-6.117h-83.56c-2.74 0-4.046 3.372-2.019 5.217l95.465 86.945 31.039 6.629 8.474 29.357z",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(305.07 166.814)",
    fill: "#ffffff",
    "data-original": "#e88f77",
    className: "",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a20.024 20.024 0 0 1-8.63 1.16c.151-2.2-.07-4.471-.68-6.71l-15.879-58c-2.531-9.25-4-18.761-4.391-28.34l-.31-7.79a71.352 71.352 0 0 0-18.36-44.97 71.229 71.229 0 0 0-18.92-14.89 71.185 71.185 0 0 0-22.79-7.75c-12.653-1.923-24.296-9.922-31.247-20.293-1.716-2.56-5.274-3.042-7.553-.967l-38.11 34.71-29.06-26.467 71.008-71.007 24.472 42.614c6.89 12 18.83 20.23 32.49 22.41a71.185 71.185 0 0 1 22.79 7.75 71.229 71.229 0 0 1 18.92 14.89 71.352 71.352 0 0 1 18.36 44.97l.31 7.79c.391 9.579 1.86 19.09 4.391 28.34l15.879 58C15.5-14.311 9.98-3.63 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(437.72 289.49)",
    fill: "#ffffff",
    "data-original": "#e08369",
    className: "",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c5.729-2.019 12.011.989 14.029 6.719l26.095 74.055a20.399 20.399 0 0 0 14.36 13.031 35.386 35.386 0 0 0 3.36 6.219l10.522 15.41a42.07 42.07 0 0 1-27.122-3.11c-10.32-4.869-18.08-13.479-21.87-24.239L-6.72 14.03C-8.739 8.3-5.73 2.019 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(371.386 196.325)",
    fill: "#ffffff",
    "data-original": "#e08369",
    className: "",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-107.307 107.307c-1.829 1.829-1.465 4.883.735 6.244 13.13 8.114 28.71 12.64 45.386 12.17 43.208-1.222 78.378-36.391 79.6-79.599.471-16.677-4.055-32.257-12.17-45.388C4.884-1.466 1.829-1.829 0 0m-145.52 41.386c-.471 16.677 4.055 32.257 12.17 45.387 1.361 2.201 4.415 2.564 6.245.735L-19.799-19.799c1.829-1.829 1.466-4.884-.734-6.244-13.13-8.114-28.71-12.641-45.386-12.17-43.208 1.221-78.379 36.391-79.601 79.599m81.967 112.368c-60.751 0-110-49.249-110-110s49.249-110 110-110 110 49.249 110 110-49.249 110-110 110",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(319.553 350.746)",
    fill: "#daa0a0",
    "data-original": "#ff7e7b",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-21.827 32.095c-7.151 10.626-2.426 25.142 9.61 29.523a19.71 19.71 0 0 0 22.068-6.13l24.45-29.926z",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(40.893 357.692)",
    fill: "#ffffff",
    "data-original": "#e08369",
    className: "",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a157.769 157.769 0 0 0-42.022 62.685l-24.524 67.373a69.886 69.886 0 0 1-11.418 20.15l-53.772 66.232a21.406 21.406 0 0 1-23.942 6.623c-13.128-4.778-18.235-20.646-10.359-32.184l31.355-45.934 15.479-9.829-1.593-11.805a20.714 20.714 0 0 1-3.224.522s-5.407-1.569-8.515-2.85c-9.597-3.953-11.541-14.506-8.8-24.517l14.871-53.339a126.695 126.695 0 0 0 4.393-28.338l.313-7.788a71.378 71.378 0 0 1 60.404-67.664c13.586-2.103 25.368-10.545 32.215-22.467l38.11-66.051a7.997 7.997 0 0 1 6.936-4.015L42-159.313h125.179c2.74 0 4.046 3.372 2.019 5.217z",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(206.93 166.814)",
    fill: "#ffffff",
    "data-original": "#e88f77",
    className: "",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-27.479a8.001 8.001 0 0 0-6.937 4.016L-74.2 73.29a45.767 45.767 0 0 1-32.489 22.41 71.177 71.177 0 0 0-22.79 7.75 71.197 71.197 0 0 0-18.92 14.89 71.353 71.353 0 0 0-18.361 44.971l-.309 7.79a127.073 127.073 0 0 1-4.391 28.339l-15.88 58c-2.809 10.24 2.71 20.92 12.691 24.55a20.016 20.016 0 0 0 8.629 1.156 20.3 20.3 0 0 1 .68-6.706l15.88-58c2.53-9.25 4-18.76 4.391-28.339l.309-7.79a71.353 71.353 0 0 1 18.361-44.971 71.197 71.197 0 0 1 18.92-14.89 71.177 71.177 0 0 1 22.79-7.75A45.767 45.767 0 0 0-52.2 92.29z",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(248.93 7.5)",
    fill: "#ffffff",
    "data-original": "#e08369",
    className: "",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-5.729-2.019-12.011.989-14.029 6.719l-26.095 74.056a20.4 20.4 0 0 1-14.36 13.03 35.298 35.298 0 0 1-3.361 6.22l-10.521 15.409a42.083 42.083 0 0 0 27.122-3.109c10.319-4.87 18.08-13.48 21.87-24.24L6.72 14.03C8.739 8.3 5.73 2.019 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(140.614 196.325)",
    fill: "#ffffff",
    "data-original": "#e08369",
    className: "",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-21.827 32.096c-7.151 10.626-2.426 25.142 9.61 29.523a19.71 19.71 0 0 0 22.068-6.13l24.45-29.927",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(40.893 357.691)",
    fill: "none",
    stroke: "#b04a4a",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-174.928 159.313a157.772 157.772 0 0 0-42.022 62.684l-24.524 67.374a69.873 69.873 0 0 1-11.418 20.15l-53.772 66.233a21.409 21.409 0 0 1-23.941 6.623c-13.128-4.778-18.236-20.647-10.36-32.186l41.874-61.345a34.958 34.958 0 0 0 3.3-6.036",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(381.857 7.5)",
    fill: "none",
    stroke: "#b04a4a",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a71.38 71.38 0 0 1 48.325-31.174 45.785 45.785 0 0 0 32.488-22.411l42.095-73.292",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(93.915 134.377)",
    fill: "none",
    stroke: "#b04a4a",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-29.742 84.426c-3.77 10.702-15.549 16.269-26.211 12.388-9.978-3.631-15.499-14.309-12.695-24.55l15.879-58a126.61 126.61 0 0 0 4.392-28.336l.314-7.788c.049-1.233.13-2.46.244-3.682",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(130.235 192.675)",
    fill: "none",
    stroke: "#b04a4a",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 21.827 32.096c7.151 10.626 2.426 25.142-9.61 29.523a19.71 19.71 0 0 1-22.068-6.13l-24.45-29.927",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(471.107 357.691)",
    fill: "none",
    stroke: "#b04a4a",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 22.339 61.371a69.873 69.873 0 0 0 11.418 20.15l53.772 66.233a21.41 21.41 0 0 0 23.942 6.623c13.128-4.778 18.235-20.647 10.359-32.186L79.956 60.846a34.778 34.778 0 0 1-3.311-6.064",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(349.277 235.5)",
    fill: "none",
    stroke: "#b04a4a",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 49.07 44.689a157.823 157.823 0 0 1 29.694 36.549",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(256 122.124)",
    fill: "none",
    stroke: "#b04a4a",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 56.912 51.832",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(130.142 7.5)",
    fill: "none",
    stroke: "#b04a4a",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a45.762 45.762 0 0 1-8.705-10.895L-21.03-32.354",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(345.977 91.686)",
    fill: "none",
    stroke: "#b04a4a",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 29.743 84.426c3.77 10.702 15.549 16.269 26.211 12.388 9.978-3.631 15.499-14.31 12.695-24.55l-15.879-58a126.61 126.61 0 0 1-4.392-28.336l-.314-7.788A71.377 71.377 0 0 0-3.908-87.692",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(381.764 192.675)",
    fill: "none",
    stroke: "#b04a4a",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-114.24 114.239c13.353 9.426 29.634 14.982 47.22 14.982 45.288 0 82-36.713 82-82C14.98 29.634 9.425 13.354 0 0Zm-144.087 19.145a81.85 81.85 0 0 0-4.933 28.076c0 17.587 5.556 33.867 14.981 47.219l114.24-114.239c-13.353-9.426-29.634-14.98-47.221-14.98-22.846 0-43.51 9.343-58.379 24.417m58.379 167.583c-60.751 0-110-49.249-110-110s49.249-110 110-110 110 49.249 110 110-49.249 110-110 110z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(323.02 347.28)",
    fill: "none",
    stroke: "#b04a4a",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScannFail5);
export default __webpack_public_path__ + "static/media/scann-fail-5.932f4386453a05f1786cf2798e1a22c4.svg";
export { ForwardRef as ReactComponent };